<script setup lang="ts">
import Content from '@desktop/views/Relation/Sports/components/RelationView/Content.vue'

import HandyInfoBar from '../../../components/RelationView/Main/PitchWithIncidents/HandyInfoBar/HandyInfoBar.vue'
import BetButtonWithIncidentsConfirmation from './Main/BetButtonWithIncidentsConfirmation/BetButtonWithIncidentsConfirmation.vue'
import MainSummary from './Main/MainSummary/MainSummary.vue'
import ParticipantHalfWithPocketIncidents from './Main/ParticipantHalfWithPocketIncidents/ParticipantHalfWithPocketIncidents.vue'
import PitchWithIncidents from './Main/PitchWithIncidents/PitchWithIncidents.vue'
</script>

<template>
  <Content>
    <template #main>
      <MainSummary />
      <ParticipantHalfWithPocketIncidents />
      <BetButtonWithIncidentsConfirmation />
      <HandyInfoBar withQueueBlockedText />
      <PitchWithIncidents />
    </template>
  </Content>
</template>
